import { useCallback } from 'react';

import { useLocalStorage } from 'common/hooks';

export const useSettings = () => {
  const [isVatEnabledLocalStorage, setIsVatEnabledLocalStorage] = useLocalStorage('insights.vat', 'false');
  const isVATEnabled = isVatEnabledLocalStorage === 'true';

  const setIsVATEnabled = useCallback(
    (isVATEnabled: boolean) => setIsVatEnabledLocalStorage(isVATEnabled.toString()),
    [setIsVatEnabledLocalStorage],
  );
  return { isVATEnabled, setIsVATEnabled };
};
